export class AssignmentSummaryCriteria {
    resourceIdList: number[];
}
